import { EditorState } from 'draft-js'
import { Subject } from 'rxjs'
import {
  AnnotationItem,
  AnnotationChild,
  AnnotationType,
} from '~/types/annotation'

export interface AnnotationData {
  categoryId: string
  itemId: string
  childId?: string
}

export interface AnnotationsModalProps {
  className?: string
  getEditorState: () => EditorState
  setEditorState: (editorState: EditorState) => void
  updateInlineToolbar: (
    visibility: boolean,
    content?: (props: any) => JSX.Element
  ) => void
  formSubject: Subject<any>
  isEditting: boolean
  annotations: Array<AnnotationType>
}

export interface AnnotationFormValue<S> {
  value: S
  label: string
}

export interface AnnotationFormData {
  category?: AnnotationFormValue<AnnotationType>
  item?: AnnotationFormValue<AnnotationItem>
  child?: AnnotationFormValue<AnnotationChild>
}

export interface AnnotationsModalState {
  hasFocus: boolean
  annotationTypes: Array<AnnotationFormValue<AnnotationType>>
  annotationItems?: Array<AnnotationFormValue<AnnotationItem>>
  annotationChildren?: Array<AnnotationFormValue<AnnotationChild>>
  annotationFormData: AnnotationFormData
  description?: string
  categoryLoading: boolean
  schemaError: boolean
  formTouched: boolean
}
